namespace $ {
	export class $shm_hitalama_map_runtime_ts extends $mol_object {

		runtime() {
			return null as any as $shm_hitalama_map_runtime
		}

		@ $mol_action
		code_rich( code: string, sync: 'async' | 'sync', context_rich: Record< string, any > ) {
			const async = sync === 'async'
			const body_prefix = this.source_prefix( sync, context_rich )
			const body_suffix = this.source_suffix( code, context_rich )
			const body = body_prefix + code + body_suffix
			const source = this.runtime().function_source(
				body,
				context_rich,
				async,
			)
			const ts = $mol_import.script( 'shm/hitalama/lib/ts/typescript.js' ).ts
			const transpiled = ts.transpileModule( source, {
				compilerOptions: {
					... this.$.$shm_hitalama_map_runtime_ts.compilerOptions,
					sourceMap: false,
					inlineSourceMap: true,
					inlineSources: true,
				},
				fileName: this.runtime().source_url( context_rich, 'tsx', this.code_widget( context_rich ) ),
			} )

			return {
				code_rich: this.runtime().runtime_sourcemap().script_with_source_url(
					transpiled.outputText,
					context_rich,
					this.code_widget( context_rich ),
				),
				context_rich,
				function_expression: true,
				source_meta: this.runtime().runtime_sourcemap().source_meta(
					this.runtime().function_header( context_rich, async ) + '\n' + body_prefix,
				),
			}
		}

		source( code: string, sync: 'async' | 'sync', context_rich: Record< string, any > ) {
			return this.source_prefix( sync, context_rich ) + code + this.source_suffix( code, context_rich )
		}

		source_prefix( sync: 'async' | 'sync', context_rich: Record< string, any > ) {
			return [
				'var $ = window;',
				this.runtime().source_js_prefix( sync, context_rich ),
			].join( '\n' )
		}

		source_suffix( code: string, context_rich: Record< string, any > ) {
			return context_rich[ '$' + 'this_widget' ]?.type() === 'component'
				? `\n;(window as any).${ code.split( ' ' )[1] } = ${ code.split( ' ' )[1] }\n`
				: ''
		}

		code_widget( context: Record< string, any > | undefined ) {
			const widget = context?.[ '$' + 'this_widget' ] as $shm_hitalama_map_widget | undefined
			return widget?.code_widget?.() ?? widget
		}

		is_context( context: Record< string, any > | undefined ) {
			const widget = context?.[ '$' + 'this_widget' ] as $shm_hitalama_map_widget | undefined
			const code_widget = this.code_widget( context )
			return [ widget?.type?.(), code_widget?.type?.() ].some( type =>
				[ 'code_ts', 'component', 'component_view', 'customdom' ].includes( type ?? '' )
			)
		}

		static compilerOptions = {
			target: 'ESNext',
			jsx: 'react',
			jsxFactory: '$mol_jsx',
			jsxFragmentFactory: '$mol_jsx_frag',
			module: 'ESNext',
			moduleResolution: 'bundler',
			esModuleInterop: true,
			noEmitHelpers: true,
			experimentalDecorators: true,
			noImplicitAny: true,
			alwaysStrict: true,
			strict: true,
			allowUnusedLabels: true,
			removeComments: true,
			sourceMap: true,
			inlineSources: true,
			declaration: true,
			skipLibCheck: false,
			skipDefaultLibCheck: true,
			types: [ 'node' ],
		}

	}
}
